/**
 * @name ngx-responsive
 * @description Devices Detect Directives for Angular
 * @author Manu Cutillas
 *
 * ```
 * #Contributors
 *  - Christophe HOARAU
 *  - Kamil Breguła
 *  - Janne Julkunen
 *  - phransyz
 *  - Michael Burger
 *  - Alyssa Brunswick
 *  - Quentin
 *  - Thomas Christensen
 * ```
 * @created_at May 04, 2016
 * @updated_at Feb 11, 2020
 * @version v9.0.0
 *
 * @angular/core : "9.x.x"
 * rxjs: "9.x.x"
 */
export * from './@core/index';
export * from './@directives/index';
export * from './responsive.module';

